import React, {useContext} from 'react';
import * as R from 'ramda';
import {RevenueCtx} from '@/contexts';
import Icon from '@/views/shared/Icon';
import {numberFormat, maybe} from '@/util';
import {Row, Col, Badge} from 'reactstrap';
import styles from '@/b2b/index.module.css';

const Detail = () => {
  const result = useContext(RevenueCtx);
  const payin = R.pathOr({}, ['payin'], result);

  return (
    <>
      <div className='row' id='payin-details'>
        <Col md={12}>
          <div className='card bg-light mt-4'>
            <div className='card-body' id='revenue-details'>
              <div className='card-title text-primary'>
                <strong>Payin Details</strong>
              </div>
              <Row>
                <Col md={2}>
                  <strong>Total Installment No.</strong>
                </Col>
                <Col md={2}>
                  <strong>Total Rate</strong>
                </Col>
                <Col md={2}>
                  <strong>No. of settled</strong>
                </Col>
                <Col md={2} className='text-right'>
                  <strong>Total Entitled Payin Amount</strong>
                </Col>
                <Col md={2} className='text-right'>
                  <strong>Total Settled Payin Amount</strong>
                </Col>
                <Col md={2} className='text-right'>
                  <strong>Total Outstanding Payin Amount</strong>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  {maybe(R.length(payin.items))
                    .map(val => val)
                    .orElse('-')}
                </Col>
                <Col md={2}>
                  {maybe(payin.totalPayinPercent).map(val =>
                    numberFormat.toPercentage(val)
                  )}
                  {maybe(payin.showBadge).map(() => (
                    <span className='badge badge-secondary'>
                      {' '}
                      <div className={styles.align_left}>
                        <div className={styles.payin_item}>
                          <div className={styles.payin_item_detail}>
                            <Icon icon='info' />
                          </div>
                          <div className={styles.payin_settlement_detail}>
                            <div
                              className={styles.payin_settlement_detail_heading}
                            >
                              <Badge color='badge badge-info'>
                                Rate Details
                              </Badge>
                            </div>
                            <div
                              className={styles.payin_settlement_item_detail}
                            >
                              <span>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>Rate</Badge>
                                  </Col>
                                  <Col md={9}>{payin.rate.rate}</Col>
                                </Row>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>
                                      Annual Bonus
                                    </Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.annualBonus}</Col>
                                  <Col md={3}>
                                    <Badge color='secondary'>
                                      Single Topup
                                    </Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.singleTopup}</Col>
                                </Row>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>Pay Term</Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.payTerm}</Col>
                                  <Col md={3}>
                                    <Badge color='secondary'>Renewal</Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.renewal}</Col>
                                </Row>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>Issue Age</Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.issueAge}</Col>
                                  <Col md={3}>
                                    <Badge color='secondary'>Trail</Badge>
                                  </Col>
                                  <Col md={3}>{payin.rate.trail}</Col>
                                </Row>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>Sum Insured</Badge>
                                  </Col>
                                  <Col md={9}>{payin.rate.sumInsured}</Col>
                                </Row>
                                <Row>
                                  <Col md={3}>
                                    <Badge color='secondary'>
                                      Effective Date
                                    </Badge>
                                  </Col>
                                  <Col md={9}>{payin.rate.effectiveDate}</Col>
                                </Row>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  ))}
                </Col>
                <Col md={2}>
                  {R.compose(
                    R.length,
                    R.filter(item => item.fullySettled === true)
                  )(R.propOr([], 'items', payin))}
                </Col>
                <Col md={2} className='text-right'>
                  {numberFormat.toDollar(payin.totalPayAmount)}
                </Col>
                <Col md={2} className='text-right'>
                  {numberFormat.toDollar(payin.totalSettledAmount)}
                </Col>
                <Col md={2} className='text-right'>
                  {numberFormat.toDollar(payin.totalOutstandingAmount)}
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </div>
    </>
  );
};

export default Detail;
